import {component} from '../form/Constant'

export const requestKey = {
    requestAccessForm: 'requestAccessForm',
    hospitals: 'hospitals',
    fullName: 'fullName',
    note: 'note',
}

export const requestOptionList = {
    requestAccessForm: [],
}

export const requestDataList = [
    {
        key: requestKey.requestAccessForm,
        description: 'Make a request to have an access to your organization',
        children: [
            {
                key: requestKey.hospitals,

                component: component.multiSelect,
                options: [],
            },
            {
                key: requestKey.fullName,
                component: component.inputText,
            },
            {
                key: requestKey.note,
                component: component.inputText,
            },
        ],
    },
]
